<template>
  <div class="department" :style={textAlign:align}>
    <el-select  clearable placeholder="一级部门" v-model="departmentOneValue" :size=size @change="getDepartmentTwo">
      <el-option
        v-for="item in departmentOneList"
        :key="item.value"
        :label="item.name"
        :value="item.value">
      </el-option>
    </el-select>
    <el-select  clearable placeholder="二级部门" v-model="departmentTwoValue" :size=size  @change="getDepartmentThree">
      <el-option
        v-for="item in departmentTwoList"
        :key="item.value"
        :label="item.name"
        :value="item.value">
      </el-option>
    </el-select>
    <el-select  clearable placeholder="三级部门" v-model="departmentThreeValue" :size=size @change="getLast">
      <el-option
        v-for="item in departmentThreeList"
        :key="item.value"
        :label="item.name"
        :value="item.value">
      </el-option>
    </el-select>
    <el-select  clearable placeholder="四级部门" v-model="departmentFourValue" :size=size @change="getFour">
      <el-option
        v-for="item in departmentFourList"
        :key="item.value"
        :label="item.name"
        :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  props: ['align', 'size', 'first', 'second', 'third', 'four', 'tableList'],
  data () {
    return {
      valueFromParent: '',
      department: [
        {
          parentId: 0,
          name: '万丈金数',
          value: '2'
        },
        {
          parentId: 0,
          name: '巍峨',
          value: '4'
        },
        {
          parentId: 0,
          name: '快信',
          value: '6'
        },
        {
          parentId: 0,
          name: '百家',
          value: '10'
        },
        {
          parentId: 2,
          name: '数据应用事业部',
          value: '32'
        },
        {
          parentId: 2,
          name: '场景运营事业部',
          value: '34'
        },
        {
          parentId: 2,
          name: '产品技术部',
          value: '36'
        },
        {
          parentId: 2,
          name: '董事长',
          value: '40'
        },
        {
          parentId: 2,
          name: '总裁',
          value: '42'
        },
        {
          parentId: 2,
          name: '董事会办公室',
          value: '44'
        },
        {
          parentId: 2,
          name: '品牌部',
          value: '46'
        },
        {
          parentId: 2,
          name: '财务部',
          value: '48'
        },
        {
          parentId: 2,
          name: '研究院',
          value: '50'
        },
        {
          parentId: 2,
          name: '人力资源部',
          value: '52'
        },
        {
          parentId: 2,
          name: '销售部',
          value: '54'
        },
        {
          parentId: 2,
          name: '总裁办',
          value: '56'
        },
        {
          parentId: 32,
          name: '客户服务部',
          value: '202'
        },
        {
          parentId: 32,
          name: '保险创新业务部',
          value: '204'
        },
        {
          parentId: 32,
          name: '银行创新业务部',
          value: '206'
        },
        {
          parentId: 34,
          name: '流量运营部',
          value: '208'
        },
        {
          parentId: 34,
          name: 'VRM部',
          value: '210'
        },
        {
          parentId: 34,
          name: '场景共建部',
          value: '212'
        },
        {
          parentId: 36,
          name: '51La',
          value: '214'
        },
        {
          parentId: 36,
          name: '测试部',
          value: '216'
        },
        {
          parentId: 36,
          name: '产品部',
          value: '218'
        },
        {
          parentId: 36,
          name: '技术研发部',
          value: '220'
        },
        {
          parentId: 48,
          name: '北京公司财务部',
          value: '222'
        },
        {
          parentId: 48,
          name: '广州财务部',
          value: '223'
        },
        {
          parentId: 50,
          name: '研究部',
          value: '224'
        },
        {
          parentId: 50,
          name: '运维部',
          value: '226'
        },
        {
          parentId: 52,
          name: '行政',
          value: '228'
        },
        {
          parentId: 52,
          name: '人力资源',
          value: '230'
        },
        {
          parentId: 54,
          name: '北京销售部',
          value: '232'
        },
        {
          parentId: 54,
          name: '上海销售部',
          value: '234'
        },
        {
          parentId: 56,
          name: '法务部',
          value: '236'
        },
        {
          parentId: 56,
          name: '科技管理部',
          value: '238'
        },
        {
          parentId: 56,
          name: '公关部',
          value: '240'
        },
        {
          parentId: 202,
          name: '数据组',
          value: '1002'
        },
        {
          parentId: 202,
          name: '实验室',
          value: '1004'
        },
        {
          parentId: 202,
          name: '项目管理部',
          value: '1006'
        },
        {
          parentId: 208,
          name: '保险教育组',
          value: '1008'
        },
        {
          parentId: 208,
          name: '信贷组',
          value: '1010'
        },
        {
          parentId: 208,
          name: '渠道拓展组',
          value: '1012'
        },
        {
          parentId: 210,
          name: '会员营销组',
          value: '1014'
        },
        {
          parentId: 210,
          name: '会员运营组',
          value: '1016'
        },
        {
          parentId: 210,
          name: '创意组',
          value: '1018'
        },
        {
          parentId: 212,
          name: '大健康共建部',
          value: '1020'
        },
        {
          parentId: 212,
          name: '大文教共建部',
          value: '1022'
        },
        {
          parentId: 212,
          name: '用户增长部',
          value: '1024'
        },
        {
          parentId: 218,
          name: '产品组',
          value: '1026'
        },
        {
          parentId: 218,
          name: '用研中心',
          value: '1028'
        },
        {
          parentId: 220,
          name: '海神前端组',
          value: '1030'
        },
        {
          parentId: 220,
          name: '海豹前端组',
          value: '1032'
        },
        {
          parentId: 220,
          name: '飞鹰后端组',
          value: '1034'
        },
        {
          parentId: 220,
          name: '战狼传说后端组',
          value: '1036'
        },
        {
          parentId: 220,
          name: '飞梦数据中台组',
          value: '1038'
        }
      ],
      departmentOneList: [],
      departmentTwoList: [],
      departmentThreeList: [],
      departmentFourList: [],
      departmentOneValue: '',
      departmentTwoValue: '',
      departmentThreeValue: '',
      departmentFourValue: ''
    }
  },
  mounted () {
    var _this = this
    this.department.forEach(function (item) {
      if (item.parentId === 0) {
        _this.departmentOneList.push(item)
      }
      if (item.parentId === 2) {
        _this.departmentTwoList.push(item)
      }
      if (item.parentId === 4) {
        _this.departmentThreeList.push(item)
      }
      if (item.parentId === 6) {
        _this.departmentFourList.push(item)
      }
    })
  },
  methods: {
    parentHandleclick (first, two, three, four) {
      var _this = this
      _this.departmentOneList = []
      _this.departmentTwoList = []
      _this.departmentThreeList = []
      _this.departmentFourList = []
      this.department.forEach(function (item) {
        if (item.parentId === 0) {
          _this.departmentOneList.push(item)
        }
        if (item.parentId === parseInt(first)) {
          _this.departmentTwoList.push(item)
        }
        if (item.parentId === parseInt(two)) {
          _this.departmentThreeList.push(item)
        }
        if (item.parentId === parseInt(three)) {
          _this.departmentFourList.push(item)
        }
      })
      this.departmentOneValue = first
      this.departmentTwoValue = two
      this.departmentThreeValue = three
      this.departmentFourValue = four
    },
    getDepartmentTwo (id) {
      this.$emit('getDepartmentOne', this.departmentOneValue)
      let _this = this
      this.departmentTwoList = []
      this.departmentTwoValue = ''
      this.departmentThreeList = []
      this.departmentThreeValue = ''
      _this.department.forEach(item => {
        if (item.parentId === parseInt(id)) {
          _this.departmentTwoList.push(item)
        }
      })
    },
    getDepartmentThree (id) {
      this.$emit('getDepartmentTwo', this.departmentTwoValue)
      let _this = this
      this.departmentThreeList = []
      this.departmentThreeValue = ''

      _this.department.forEach(function (item) {
        if (item.parentId === parseInt(id)) {
          _this.departmentThreeList.push(item)
        }
      })
    },
    getLast (id) {
      this.$emit('getDepartmentThree', this.departmentThreeValue)
      let _this = this
      this.departmentFourList = []
      this.departmentFourValue = ''

      _this.department.forEach(function (item) {
        if (item.parentId === parseInt(id)) {
          _this.departmentFourList.push(item)
        }
      })
    },
    getFour () {
      this.$emit('getDepartmentFour', this.departmentFourValue)
    },
    getClear () {
      this.departmentOneValue = ''
      this.departmentTwoValue = ''
      this.departmentThreeValue = ''
      this.departmentFourValue = ''
      this.$emit('getDepartmentOne', this.departmentOneValue)
      this.$emit('getDepartmentTwo', this.departmentTwoValue)
      this.$emit('getDepartmentThree', this.departmentThreeValue)
      this.$emit('getDepartmentFour', this.departmentFourValue)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.department {
  .el-select {
    width: 150px;
  }
  .el-select:not(:first-child) {
    margin-left: 10px;
  }
}
</style>
